module.exports = __webpack_public_path__ + "1a2edfe0a56afbc56446d7a15c987165.svg";